
import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Modal,FormControl,Button,ButtonToolbar,Tabs,Tab} from 'react-bootstrap'
import {Box} from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select'
import WorkdocStore from '../../stores/WorkdocStore'
import ScheduledServicePlan from 'view/ssp/ScheduledServicePlan'

class SWTProgramModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,programType:'general',sspData:null,tableData:[],tablePartData:[],pgmSelect:'',pgmOptions:[],rowEdit:-1,rowPartEdit:-1}
  }

  onShow(){
    this.openPopup()
  }

  openPopup(){
    this.setState({loading:true})
    
    WorkdocStore.loadProgram((result)=>{
      this.setState({loading:false,pgmOptions:result.data})
    })
  }

  getOptions(data){
    return data.map((item,index)=>{
      return {label:item.name,value:index}
    })
  }

  onClearClick(){
    this.setState({query:''})
  }

  onAddToListClick(){
    let {pgmSelect,tableData,tablePartData,pgmOptions,programType,sspData} = this.state

    if(programType=='general' && pgmSelect!==''){
      this.props.onSelect(tableData,tablePartData,pgmOptions[pgmSelect])
      this.props.onHide()
    }else if(programType=='ssp' && sspData!==null){  
      let part = sspData['liquid'].concat(sspData['part']);
      this.props.onSelect(sspData['wage'],part,{program_id:200,program_name:'Test 2',total_price:'5000',name:'เช็คระยะ '})
      this.props.onHide()
    }else{
      // alert('กรุณาเลือกโปรแกรม')
    }
  }

  onPlanSelect(data){
    this.setState({sspData:data})
  }

  onEditClick(row){
    //console.log('rowEdit',row)
    this.setState({rowEdit:row})
  }

  onPartEditClick(row){
    //console.log('rowEdit',row)
    this.setState({rowPartEdit:row})
  }

  onSaveClick(row){
    this.setState({rowEdit:-1})
  }

  onPartSaveClick(row){
    this.setState({rowPartEdit:-1})
  }

  onDeleteClick(row){

  }

  onPartDeleteClick(row){
    
  }

  onRowClick(){
    
  }

  onRowDataChange(row,field,e){
    let {tableData}  = this.state
    tableData[row][field] = e.target.value
    this.setState({tableData:tableData})
  }
  

  onProgramChange(value){
    console.log('vlaue',value)
    let {pgmOptions} = this.state
    let pgmSelect = value.value
    
    this.setState({loading:true,pgmSelect:pgmSelect})
    
    let program = pgmOptions[pgmSelect]
    WorkdocStore.loadProgramWageItem(program.program_id,(result)=>{
      this.setState({loading:false,tableData:result.data.wagelist,tablePartData:result.data.partlist})
    })
  }
  

  onProgramTypeChange(e){
    this.setState({programType:e})
  }

  renderSearch(){
    let {pgmSelect,pgmOptions} = this.state
    let {messages} = this.props
    return (
      <div className='row form-group'>
        
        <div className='col-md-12' style={{display:'inline-flex'}}>
          <Select style={{width:'500px'}}
          placeholder={messages['Select Program']}
          clearable={false}
          value={pgmSelect}
          options={this.getOptions(pgmOptions)}
          onChange={this.onProgramChange.bind(this)}
          />  
          <ButtonToolbar style={{width:'410px',marginLeft:'10px'}}>
            
            
          </ButtonToolbar>
        </div> 

      </div>
    )
  }

  renderRowControl(item,row,field,readonly){
    let {messages} = this.props
    if(readonly){
      return (<span>{item[field]}</span>)
    }else{
      return (<FormControl value={item[field]} placeholder={messages['Put Data']} onChange={this.onRowDataChange.bind(this,row,field)}/>)
    }
  }

  renderRowData(){
    let {tableData,rowEdit} = this.state
    //console.log('rowEdit',rowEdit)
    if(tableData.length===0){
      return (
        <tr>
          <td colSpan={5}>ไม่พบข้อมูล...</td>
        </tr>
      )
    }
    return tableData.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'  onClick={this.onRowClick.bind(this,item)}>{index+1}</td>        
        <td  onClick={this.onRowClick.bind(this,item)}>{this.renderRowControl(item,index,'servicecode',rowEdit!==index)}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{this.renderRowControl(item,index,'detail',rowEdit!==index)}</td>
        <td  onClick={this.onRowClick.bind(this,item)} className='text-right'>{this.renderRowControl(item,index,'quantity',rowEdit!==index)}</td>
        <td  onClick={this.onRowClick.bind(this,item)} className='text-right'>{this.renderRowControl(item,index,'wage_cost',rowEdit!==index)}</td>
      </tr>
    )) 
  }
//   <td className='text-center'>
//   <ButtonToolbar>
//     <Button style={{display:(rowEdit===index)?'block':'none'}} bsStyle={"primary"} onClick={this.onSaveClick.bind(this,index)}>บันทึก</Button>
//     <Button style={{display:(rowEdit!==index)?'block':'none'}} onClick={this.onEditClick.bind(this,index)}>แก้ไข</Button>
//     <Button bsStyle={"danger"} onClick={this.onDeleteClick.bind(this,index)}>ลบ</Button>
//   </ButtonToolbar>
// </td>

  renderRowPartData(){
    let {tablePartData,rowEdit} = this.state
    //console.log('rowEdit',rowEdit)
    if(tablePartData.length===0){
      return (
        <tr>
          <td colSpan={5}>ไม่พบข้อมูล...</td>
        </tr>
      )
    }
    return tablePartData.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'  onClick={this.onRowClick.bind(this,item)}>{index+1}</td>        
        <td  onClick={this.onRowClick.bind(this,item)} className='text-right'>{this.renderRowControl(item,index,'productcode',rowEdit!==index)}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{this.renderRowControl(item,index,'detail',rowEdit!==index)}</td>
        <td  onClick={this.onRowClick.bind(this,item)} className='text-right'>{this.renderRowControl(item,index,'quantity',rowEdit!==index)}</td>
        <td  onClick={this.onRowClick.bind(this,item)} className='text-right'>{this.renderRowControl(item,index,'price_per_unit',rowEdit!==index)}</td>        
        
      </tr>
    )) 
  }

  renderSearchResult(){
    let {messages} = this.props
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th style={{width:'50px'}}>#ID</th>            
            <th style={{width:'150px'}} className='text-center'>{messages['ServiceCode']}</th>
            <th className='text-center'>{messages['Item']}</th>
            <th style={{width:'100px'}} className='text-center'>{messages['Quantity']}</th>
            <th style={{width:'100px'}} className='text-center'>{messages['Price']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        
      </table>
    )
  }

  renderPartResult(){
    let {messages} = this.props
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th style={{width:'50px'}}>#ID</th>  
            <th style={{width:'150px'}} className='text-center'>{messages['Part No.']}</th>          
            <th className='text-center'>{messages['Item']}</th>
            <th style={{width:'100px'}} className='text-center'>{messages['Quantity']}</th>
            <th style={{width:'100px'}} className='text-center'>{messages['Price/Unit']}</th>            
            
          </tr>
        </thead>
        <tbody>
          {this.renderRowPartData()}
        </tbody>
        
      </table>
    )
  }

  renderGeneralProgram(){
    let {loading,messages} = this.props
    return (
      <Box loading={loading}>
        <Box.Body>
        {this.renderSearch()}
        <h4 className='text-center'>{messages['Wages']}</h4>
        {this.renderSearchResult()} 
        <h4 className='text-center'>{messages['Parts']}</h4>
        {this.renderPartResult()}             
      </Box.Body>
    </Box> 
    )
  }

  renderServicePlanProgram(){
    let initSsp = Object.assign({brandSel:'',modelSel:'',seriesSel:'',mileageSel:0,workNo:this.props.workNo},this.props.initSsp)
    return (
      <ScheduledServicePlan {...initSsp}  onSelect={this.onPlanSelect.bind(this)}/>
    )
  }

  render(){
    let {show,messages} = this.props
    let {loading,programType,pgmSelect,sspData} = this.state
    return (
      <Modal show={show} onShow={this.onShow.bind(this)} enforceFocus={false} onHide={this.props.onHide} dialogClassName="fullwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{messages['Select Program']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Tabs 
        activeKey={programType}
        onSelect={this.onProgramTypeChange.bind(this)}        
        id="program-tab">
          <Tab eventKey={'general'} title={(<span><FontAwesome name='car'/> โปรแกรมทั่วไป</span>)}>
            {programType=='general' && this.renderGeneralProgram()}  
          </Tab>
          <Tab eventKey={'ssp'} title={(<span><FontAwesome name='road'/> ระบุรุ่น/เช็คตามระยะ</span>)}>
            {programType=='ssp' && this.renderServicePlanProgram()}
          </Tab>
        </Tabs>;
                      
              
          
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle={'primary'} disabled={((pgmSelect==='' && programType==='general') || (sspData===null && programType==='ssp') )} onClick={this.onAddToListClick.bind(this)}><FontAwesome name="plus"/>&nbsp;{messages['Put To Item']}</Button>
            <Button onClick={this.props.onHide}><FontAwesome name='close'/>&nbsp;{messages['Close']}</Button>
          </ButtonToolbar>        
        </Modal.Footer>
      </Modal>
    )
  }
}

SWTProgramModal.defaultProps = {
  initSsp : {brandSel:'',modelSel:'',seriesSel:'',mileageSel:0},
  workNo:''
}

export default SWTProgramModal = connect(
  (state) => ({messages: state.message.view.workdoc.SWTProgramModal}),null,null,{withRef:true}
)(SWTProgramModal);





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTProgramModal.js